const Invoices = () => {
  return <>Invoices</>;
};

export default Invoices;
